import $ from 'jquery';
import picturefill from 'picturefill';
import {isMobile, addMobileClass, removeMobileClass, wooButtons, lastBlock} from './utilities';

import './utilities/share';
import './components/nav';
import './components/carousel';
import './components/carouselMobile';
import './components/tabs';
import './components/strip_call-out';
import './components/strip_offset';
import './components/accordion';
import './components/modal';
import './components/modalCarousel';
import './components/testimonials';
import './components/golfCarousel';
import './components/categories';
import './components/rateCalculator';
import './components/subnav';
import './templates/product';
import alertBanner from './components/alertBanner';
import slider from './components/slider';
import subnav from './components/subnav';
import moduleLightbox from './components/moduleLightbox';
import floorplan from './components/floorplan';
import roomsFilter from './components/roomsFilter';
import acc from './components/acc';
import logosMobile from './components/logosMobile';
import imageSliderAlt from './components/imageSliderAlt';
import contentImageSlider from './components/contentImageSlider';
import videoEmbedPlayButton from './components/video-embed';

class Main {
  constructor(){
    this.addListeners();
    isMobile() ? addMobileClass() : removeMobileClass();
  }

  addListeners(){
    $(window).on('resize', () => {
      isMobile() ? addMobileClass() : removeMobileClass();
    });
  }
}

new Main();

window.addEventListener('DOMContentLoaded', function() {
  alertBanner();
  slider();
  wooButtons();
  subnav();
  moduleLightbox();
	floorplan();
	roomsFilter();
	acc();
	logosMobile();
	imageSliderAlt();
	contentImageSlider();
	lastBlock();
	videoEmbedPlayButton();
});
